import React, { Component } from 'react';
import './spinDialog.less';
import { Spin } from 'antd';



//设备设置界面
export default class SpinDialog extends Component {
    constructor(a) {
        super(a);
    }


    render() {
        return (
            <div className="spin_container">
                <div className="spin_grey_bg" />
                <div className="spin_dialog" style={{left:(document.body.clientWidth-100)/2}}>
                     <Spin className='loading' size="large"></Spin>
                </div>
            </div>
        );

    }
};